import {
    endOfMonth,
    endOfQuarter,
    endOfYear,
    format,
    isSameDay,
    startOfMonth,
    startOfQuarter,
    startOfYear,
} from "date-fns";

export function formatExactDateRangePeriod(
    start: Date,
    end: Date,
): string | undefined {
    if (
        isSameDay(start, startOfYear(start)) &&
        isSameDay(end, endOfYear(start))
    ) {
        return format(start, "yyyy");
    }
    if (
        isSameDay(start, startOfQuarter(start)) &&
        isSameDay(end, endOfQuarter(start))
    ) {
        return format(start, "'Q'Q yyyy");
    }
    if (
        isSameDay(start, startOfMonth(start)) &&
        isSameDay(end, endOfMonth(start))
    ) {
        return format(start, "MMMM yyyy");
    }
    return undefined;
}
